<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" clearable placeholder="请输入姓名或身份证号"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>

          <a-col :md="10" :sm="24">
            <a-form-item label="申报日期">
              <a-range-picker
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="星级">
              <a-select v-model="queryParam.grade" placeholder="请选择"
                        allowClear >
                <a-select-option     title="幼儿初" value="幼儿初">幼儿初</a-select-option>
                <a-select-option     title="幼儿中" value="幼儿中">幼儿中</a-select-option>
                <a-select-option    title="幼儿高" value="幼儿高">幼儿高</a-select-option>
                <a-select-option value="红">红</a-select-option>
                <a-select-option value="橙">橙</a-select-option>
                <a-select-option value="黄">黄</a-select-option>
                <a-select-option value="绿">绿</a-select-option>
                <a-select-option value="青">青</a-select-option>
                <a-select-option value="蓝">蓝</a-select-option>
                <a-select-option value="紫">紫</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>


          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator"  v-if="$auth('KaojiApply')" >
      <a-button @click="download('',3)" style="margin-left: 8px">
        考级人员明细表
        <a-icon type="download" />
      </a-button>
      <a-button @click="download('',4)" style="margin-left: 8px">
        年度机构考级人数统计表
        <a-icon type="download" />
      </a-button>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="userColumns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name1" slot-scope="text,record">
          <div>
            {{ record.name }}
            <br/>
            <span style="color: #999">{{ record.danwei  }} {{record.old_danwei}}</span>
            <br/>
            {{ record.num }}
            <br/>
            等级:{{ record.grade }}
          </div>
      </span>
    <div slot="huankao1" slot-scope="text,record"  >

      <span  v-if="$auth('KaojiApply')" >
          <r-switch  :formData="record" field="huankao" @change="setHuankao(record)" :checkedValue="1" :unCheckedValue="2" checkedChildren="缓考" unCheckedChildren="否" />
      </span>
      <p  v-else>
        <span v-if="record.huankao==1">缓考</span>
        <span v-else>否</span> 
      </p>

    </div>
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.user_name }}
            <br/>
            上传时间 {{ record.create_time|timeFormat }}
            <br/>
            注册时间 {{ record.today|timeFormat }}
          </div>
      </span>
      <span slot="jindu" slot-scope="text,record">
        人数{{ record.membercount }}<br/>
        <a-tag v-if="record.status==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.status==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
        <br/>
        <a v-if="record.resultszip && record.resultszip2">成绩已上传</a>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <span  v-if="$auth('KaojiApply')" ><a @click="handleEdit(record)" >编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a-divider type="vertical"/>
          <a  @click="handlePici(record)">申报批次</a>
          <br/></span>
         <a-dropdown>
           <a class="ant-dropdown-link">
             下载证书 <a-icon type="down"/>
           </a>
           <a-menu slot="overlay">
             <a-menu-item @click="download(record,1)">打印证书</a-menu-item>
             <a-menu-item @click="download(record,2)">电子证书</a-menu-item>
           </a-menu>
]        </a-dropdown>
        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
        title="人员操作"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userFormVisible"
        @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                         placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                         placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>


          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="等级"
                  :extra="'¥'+userFormData.kaoji_price1+'(红) , ¥'+userFormData.kaoji_price2+'(橙) , ¥'+userFormData.kaoji_price3+'(黄) , ¥'+userFormData.kaoji_price4+'(绿) , ¥'+userFormData.kaoji_price5+'(青) , ¥'+userFormData.kaoji_price6+'(蓝) , ¥'+userFormData.kaoji_price7+'(紫)'"
                  hasFeedback
              >

                <a-select
                    showSearch
                    optionFilterProp="title"
                    v-model="userFormData.grade"
                    placeholder="星级"
                    allowClear
                >
                <a-select-option     title="幼儿初" value="幼儿初">幼儿初</a-select-option>
                <a-select-option     title="幼儿中" value="幼儿中">幼儿中</a-select-option>
                <a-select-option    title="幼儿高" value="幼儿高">幼儿高</a-select-option>
                  <a-select-option title="红" value="红">红</a-select-option>
                  <a-select-option title="橙" value="橙">橙</a-select-option>
                  <a-select-option title="黄" value="黄">黄</a-select-option>
                  <a-select-option title="绿" value="绿">绿</a-select-option>
                  <a-select-option title="青" value="青">青</a-select-option>
                  <a-select-option title="蓝" value="蓝">蓝</a-select-option>
                  <a-select-option title="紫" value="紫">紫</a-select-option>
                </a-select>

              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="性别"
                  hasFeedback
              >
                <a-select
                    showSearch
                    optionFilterProp="title"
                    v-model="userFormData.sex"
                    placeholder="性别"
                    allowClear
                >
                  <a-select-option title="男" value="1">男</a-select-option>
                  <a-select-option title="女" value="2">女</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

              <a-form-item
                  label="证件照片"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
                <pic-uploader
                    :file-list="userFormData.pic"
                />
              </a-form-item>
            </a-col>


          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="家长姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
              'famliy_name',
              {rules: []}
            ]"
                         placeholder="请输入家长姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="家长身份证"
                  hasFeedback
              >
                <a-input v-decorator="[
              'famliy_num',
              {rules: [ ]}
            ]"
                         placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系方式"
                  hasFeedback
              >
                <a-input v-decorator="[
              'phone',
              {rules: []}
            ]"
                         placeholder="请输入联系方式"/>
              </a-form-item>
            </a-col>


          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="衣服尺码"
                  hasFeedback
              >
                <a-input v-decorator="[
              'csize',
              {rules: []}
            ]" placeholder="请输入衣服尺码"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="鞋子尺码"
                  hasFeedback
              >
                <a-input v-decorator="[
              'footsize',
              {rules: [ ]}
            ]"
                         placeholder="请输入鞋子尺码"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="购买衣服"
                  :extra="'¥'+userFormData.clothes_price"
                  hasFeedback
              >
                <r-switch :formData="userFormData" field="buyc" :disabled="userFormData.pay_status==2" :checkedValue="1"
                          :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="购买鞋子"
                  :extra="'¥'+userFormData.shoes_price"
                  hasFeedback
              >
                <r-switch :formData="userFormData" field="buys" :disabled="userFormData.pay_status==2" :checkedValue="1"
                          :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否"/>
              </a-form-item>
            </a-col>

          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleUserFormCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
    </a-modal>

  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import KaoguanPicker from '@/components/KaoguanPicker/'
import JianduPicker from '@/components/JianduPicker/'
import RSwitch from '@/components/RSwitch/'
import areaOptions from '@/utils/area'
import moment from 'moment' 
import qs from 'qs' 

import 'moment/locale/zh-cn';

moment.locale('zh-cn');

import {deleteApplyUser, editApplyUser, getApplyUserDetail, getKaojiMemberList, refreshOrder} from '@/api/qcxj'
import {setHuankaoStatus} from '@/api/kaojiexame'
import setting from "@/config/setting";

export default {
  name: 'KaojiMemberList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    KaoguanPicker,
    JianduPicker,
    RSwitch
  },
  data() {
    return {
      areaOptions,
      userFormVisible: false,
      kaoguanPickerShow: false,
      jianduPickerShow: false,
      userVisible: false,
      visible: false,
      saveLoading: false,
      formData: {
        id: 0,
        danwei: '',
        datetitle_moment: null,
        datetitle: '',
        resultszip: [],
        kaoguan: [],
        jiandu: [],
        namekeys: [],
        areas: [],
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '单位信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        {
          title: '状态',
          dataIndex: 'jindu',
          scopedSlots: {customRender: 'jindu'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],


      //领取人员表头
      userColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '人员信息',
          dataIndex: 'name',
          width: '150px',
          scopedSlots: {
            customRender: 'name1',
          }
        },
        // {
        //   title: '身份证',
        //   dataIndex: 'num'
        // },
        // {
        //   title: '等级',
        //   width: '100px',
        //   dataIndex: 'grade',
        // },
        {
          title: '价格',
          width: '100px',
          dataIndex: 'price',
        },
        {
          title: '缓考',
          width: '100px',
          scopedSlots: {
            customRender: 'huankao1',
          }
        },
        {
          title: '注册时间',
          width: '150px',
          dataIndex: 'create_time',
          customRender: (text) => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss');
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: {
            customRender: 'action',
          }
        },
      ],
      userPagination: {},
      userQuery: {
        manageid: 0,
        status: 0,
        page: 1,
        keywords: undefined
      },
      userFormData: {
        id: 0,
        pic: []
      },
      kaojiUserList: [],


      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getKaojiMemberList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      }
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
  },
  methods: {
    moment,
    handleCancel() {
      this.visible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    setHuankao(record) {
      let self = this
      self.saveLoading = true;
      console.log('setHuankao', record)
      setHuankaoStatus({
        id: record.id,
        status: record.huankao,
      }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(false)
        self.saveLoading = false;
      }).catch(err => {
        self.$message.error(err.data.msg);
        self.saveLoading = false;
      })
    },
    handleEdit(record) {
      let self = this
      this.userFormVisible = true
      getApplyUserDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.userFormData.id = record.id;
          self.userFormData = {...res.data};
        }, 200)
      }).catch(res  =>{
        console.log(res)
      })
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
    deleteHandle(record) {
      let self = this
      deleteApplyUser({id: record.id}).then(res => {
        self.$refs.table.refresh(false)
      })
    },
    // 增改 处理
    handleUserFormOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.userFormData)
          self.saveLoading = true;
          editApplyUser({
            id: self.userFormData.id,
            name: values.name,
            num: values.num,
            sex:self.userFormData.sex,
            grade: self.userFormData.grade,
            pic: self.userFormData.pic,
            buyc: self.userFormData.buyc,
            buys: self.userFormData.buys,
            footsize: values.footsize,
            csize: values.csize,
            famliy_name: values.famliy_name,
            famliy_num: values.famliy_num,
            phone: values.phone,
          }).then(res => {
            self.$message.success('修改成功')

            self.$refs.table.refresh(false)
            self.userFormVisible = false;
            self.saveLoading = false;
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })

        }
      })
    },

    handleUserFormCancel() {
      this.userFormVisible = false
    },

    refreshPrice() {
      let self = this
      refreshOrder({baoming_id: self.orderFormData.baoming_id}).then(res => {
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        });
      })
    },

    userSearch(selectedKeys, confirm) {
      let self = this
      confirm();
      self.fetchUserList();
    },
    userSearchReset(selectedKeys, confirm) {
      let self = this;
      confirm();
      self.userQuery.keywords = undefined;
      self.fetchUserList();
    },
    handleUserTableChange(pagination, filters, sorter) {
      console.log('filters', filters);
      let that = this;
      if (filters.grade) {
        that.userQuery.grade = filters.grade[0];
      } else {
        that.userQuery.grade = '';
      }
      const pager = {...this.pagination};
      pager.current = pagination.current;
      that.pagination = pager;
      that.userQuery.page = pagination.current;
      that.fetchUserList();
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },


    handlePici(record) {
      const { href } = this.$router.resolve({
        name: "KaojiApplyList",
        query: { id: record.kaoji_id },
      }); 
      window.open(href, "_blank");
    },

    download(record, type) {
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/kaojiexame/downloadCertP?id=' + record.qcxj_exame_id);
          break;
        case 2 :
          window.open(setting.apiBaseURL + '/adminapi/kaojiexame/downloadCert?id=' + record.qcxj_exame_id);
          break;
          case 3 :
            window.open(setting.apiBaseURL + '/adminapi/qcxj/kaojimemberdownload?' + qs.stringify(this.queryParam));
            break;
          case 4 :
            if(this.time_range_moment.length==0){
              this.$message.error('请选择日期');
              return ;
            }
            let year = this.time_range_moment[0].format('YYYY');
            window.open(setting.apiBaseURL + '/adminapi/qcxj/kaojiMemberYearDownload?year=' + year)
            break;
      }
    }

  },
  filters: {},
  watch: {}
}
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
